<template>
  <div class="eds-comp-task-info" @click="showTask(taskInfo)">
    <div>
      <v-icon :color="taskIconColor" style="height: 30px; vertical-align: middle; margin-right: 5px">{{ taskIcon
      }}</v-icon>
      <span style="font-weight: bold">{{ FLOW_Type[taskInfo.workflowType].name }}</span>
      <span style="font-weight: bold" v-if="isDev">({{ taskInfo.id + $t('测试') }})</span>
    </div>
    <div class="task_content_main">
      <div class="eds_content2">
        <span class="eds_content_prop">{{ $t('申请描述') }}</span>
        <span class="eds_content_value">{{ taskInfo.workflowTitle }}</span>
      </div>
      <div class="eds_content2">
        <span class="eds_content_prop">{{ $t('任务名称') }}</span>
        <span class="eds_content_value">{{ $t(taskInfo.node.name) }}</span>
      </div>
      <v-divider></v-divider>
      <div class="eds_content_footer">
        <span class="eds-content__time">{{ createDate }}</span>
        <span :class="waitingTimeClass" class="eds-content__waiting-time">{{ waitingTime }}</span>
        <div class="eds_content_btns" v-if="taskInfo.state == 'awaiting'">
          <template v-if="showApprove(taskInfo)">
            <v-btn small flat color="primary" @click="(e) => { reject(e) }">{{ $t('拒绝') }}</v-btn>
            <v-btn small flat color="primary" @click="(e) => { approve(e) }">{{ $t('同意') }}</v-btn>
          </template>
          <template v-else-if="showReview(taskInfo)">
            <v-btn small flat color="primary" @click="(e) => { review(e) }">{{ $t('审阅') }}</v-btn>
          </template>
          <template v-if="showHandleFile(taskInfo)">
            <v-btn small flat color="primary" @click="(e) => { handleFile(e) }">{{ $t('文件处理') }}</v-btn>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import msgbus from '../msgBus'
import devHelper from '../util/devHelper'
import debugHelper from '../util/debug'
import dbHelper from '../util/db'
import dateHelper from '../util/date'
import { WORKFLOW_NODE_TYPE, FLOW_TYPE16, TASK_STATE16 } from '../config/work'

export default {
  name: 'eDSCompTaskInfo16',
  props: {
    taskInfo: {
      type: Object,
      required: false,
    },
    workflowType: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
    }
  },
  computed: {
    isDev() {
      return devHelper.isDevMode() // 判断是否开启了测试模式
    },
    FLOW_Type() {
      return this.workflowType ? this.workflowType : FLOW_TYPE16
    },
    taskIcon() {
      return this.taskInfo ? TASK_STATE16[this.taskInfo.state].icon : ''
    },
    taskIconColor() {
      return this.taskInfo ? TASK_STATE16[this.taskInfo.state].color : ''
    },
    createDate() {
      let createAtUnit = dateHelper.string2Timestamp(this.taskInfo.createdAt)
      if (this.waitingTime) {
        return dateHelper.timestamp2LocalDate(createAtUnit)
      }
      return dateHelper.timestamp2LocalTime(createAtUnit)
    },
    waitingTime() {
      console.log('调试代码')
      if (this.taskInfo.state === 'approved') {
        return this.$t('已同意')
      } else if (this.taskInfo.state === 'rejected') {
        return this.$t('已拒绝')
      } else if (this.taskInfo.state === 'terminated') {
        return this.$t('已终止')
      }
      let createAtUnit = dateHelper.string2Timestamp(this.taskInfo.createdAt)
      const wait = dateHelper.unixFromNow(createAtUnit, null, 'minute')
      return wait
    },
    waitingTimeClass() {
      const classes = []
      if (this.taskInfo.state === 'approved' || this.taskInfo.state === 'rejected') {
        classes.push('dl-gray')
      } else {
        const fromVal = this.taskInfo.createdAt - Math.floor(Date.now() / 1000)
        if (fromVal > -21600) {
          classes.push('dl-gray')
        } else if (fromVal > -86400) {
          classes.push('dl-orange')
        } else {
          classes.push('dl-red')
        }
      }
      return classes.join(' ')
    }
  },
  methods: {
    showApprove(task) {
      if (task.nodeType == WORKFLOW_NODE_TYPE.Approve || task.nodeType == WORKFLOW_NODE_TYPE.AddApprove)
        return true
      return false
    },
    showReview(task) {
      if (task.nodeType == WORKFLOW_NODE_TYPE.CC)
        return true
      return false
    },
    showHandleFile(task) {
      if (task.nodeType == WORKFLOW_NODE_TYPE.FileProc)
        return true
      return false
    },

    // 显示任务详情
    showTask(task) {
      var scroll = document.getElementsByClassName('scroll-container')[0]
      debugHelper.log('存储scrollTop : ' + scroll.scrollTop)
      dbHelper.set('taskListScrollTop', scroll.scrollTop)
      dbHelper.set('taskListRecordCount', msgbus.vm.getTaskListRecordCount())

      this.$router.push({
        name: 'flowinfo16',
        params: {
          flowID: this.taskInfo.workflowID,
          flowTid: msgbus.vm.getCurrentTenantID(),
        },
      })
    },
    // 拒绝
    reject(e) {
      e.stopPropagation()

      var scroll = document.getElementsByClassName('scroll-container')[0]
      debugHelper.log('存储scrollTop : ' + scroll.scrollTop)
      dbHelper.set('taskListScrollTop', scroll.scrollTop)
      dbHelper.set('taskListRecordCount', msgbus.vm.getTaskListRecordCount())

      this.$router.push({
        name: 'taskrefuse',
        params: {
          taskInfo: this.taskInfo,
          taskTid: msgbus.vm.getCurrentTenantID(),
        },
      })
    },
    // 同意
    approve(e) {
      e.stopPropagation()

      var scroll = document.getElementsByClassName('scroll-container')[0]
      debugHelper.log('存储scrollTop : ' + scroll.scrollTop)
      dbHelper.set('taskListScrollTop', scroll.scrollTop)
      dbHelper.set('taskListRecordCount', msgbus.vm.getTaskListRecordCount())

      this.$router.push({
        name: 'taskagree',
        params: {
          taskInfo: this.taskInfo,
          taskTid: msgbus.vm.getCurrentTenantID(),
        },
      })
    },

    // 审阅
    review(e) {
      e.stopPropagation()
      alert('正在建设中......')
    },

    // 文件处理
    handleFile(e) {
      e.stopPropagation()
      alert('正在建设中......')
    },
  },
  created() {
    console.log('调试代码')
  },
  mounted() { },
}
</script>


<style lang="scss">
.eds-comp-task-info {
  .task_content_main {
    margin-top: 10px;
    margin-left: 30px;

    &>.eds_content2 {
      margin-right: 20px;
    }

    & .eds_content_footer {
      position: relative;

      &>.eds-content__time {
        color: rgba(138, 138, 138, 1);
        line-height: 28px;
      }

      &>.eds-content__waiting-time {
        margin-left: 10px;
        color: rgba(138, 138, 138, 1);
        line-height: 28px;
      }

      .eds_content_btns {
        position: absolute;
        top: 0;
        right: 10px;

        &>.v-btn {
          min-width: 50px;
          padding: 0 16px !important;
          margin: 0 !important;

          &:nth-child(n + 2) {
            &::after {
              content: "";
              position: absolute;
              height: 50%;
              border-right: 1px solid rgba(196, 196, 196, .5);
              left: 0;
              top: 50%;
              transform: translateY(-50%);
            }
          }
        }
      }
    }
  }
}
</style>